var _title, _desc, _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEpub = function SvgEpub(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "90px",
    viewBox: "0 0 70 90",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "epub-ico copy")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.09090909,-3.65858376e-16 L45.411377,-4.06123242e-15 L59.375,14.4848633 L59.375,75.9090909 C59.375,78.1684376 57.5434376,80 55.2840909,80 L4.09090909,80 C1.83156239,80 -6.11488249e-16,78.1684376 -8.8817842e-16,75.9090909 L0,4.09090909 C-2.76690171e-16,1.83156239 1.83156239,3.07957052e-15 4.09090909,2.66453526e-15 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-14.3%",
    y: "-8.1%",
    width: "128.6%",
    height: "121.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "45.625 0 59.588623 14.4848633 45.625 14.4848633"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-46.5%",
    y: "-38.0%",
    width: "193.1%",
    height: "189.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIDE-Kit-Copy-2",
    transform: "translate(-4296.000000, -949.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "epub-ico-copy",
    transform: "translate(4301.000000, 952.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-21",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D6D6D6",
    strokeWidth: 1,
    d: "M58.875,14.6866243 L45.1988837,0.5 L4.09090909,0.5 C2.10770476,0.5 0.5,2.10770476 0.5,4.09090909 L0.5,75.9090909 C0.5,77.8922952 2.10770476,79.5 4.09090909,79.5 L55.2840909,79.5 C57.2672952,79.5 58.875,77.8922952 58.875,75.9090909 L58.875,14.6866243 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-21-Copy",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DFDFDF",
    strokeWidth: 1,
    d: "M46.125,1.23908949 L46.125,13.9848633 L58.412115,13.9848633 L46.125,1.23908949 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.7706813,33.3160301 C46.3741461,31.7122718 46.374733,29.1118127 44.7706813,27.5080545 L30.4119689,41.8664734 L18.9576845,30.412189 L30.4119689,18.9579045 L34.6868972,23.2328328 L28.1245742,29.7957426 L31.0284153,32.6995837 L39.0428056,24.6849001 C39.8452715,23.8830209 39.8452715,22.5826447 39.0428056,21.7807655 L31.8637428,14.6014093 C31.0618636,13.7995302 29.7620742,13.7995302 28.9599017,14.6014093 L14.6011893,28.9598283 C13.7996036,29.7617074 13.7996036,31.0620837 14.6011893,31.8639628 L28.9599017,46.2223818 C29.7620742,47.0242609 31.0618636,47.0242609 31.8637428,46.2223818 L44.7706813,33.3160301 Z",
    id: "Path",
    fill: "#007934"
  }), /*#__PURE__*/React.createElement("text", {
    id: ".epub",
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontSize: 16.3636364,
    fontWeight: 500,
    fill: "#4F5E65"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.08531605,
    y: 68.9090909
  }, ".epub")))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEpub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/epub.0fa3b37b.svg";
export { ForwardRef as ReactComponent };